import React from 'react';
import { useHistory } from 'react-router-dom';

import SectionImg from './SectionImg';
import Slider from './Slider';

import {pics, agencyInfo} from '../data/aboutData';
import courseData from '../data/coursesData';

// Get list of available agencies from courses data
const availableAgencies = courseData.map(course => course.agency);

const collapseHandler = (name) => {
  const elem = document.getElementById(`${name}learnMore`);
  if (elem) {
    elem.classList.toggle('aboutLearnMoreCollapse');
  }
  return
}


const About = () => {
  const history = useHistory();

  const handleCourseNavigation = (agencyName) => {
    if (agencyName) {
      history.push(`/courses/${agencyName}`);
    } else {
      history.push('/courses');
    }
  };

  return (
    <div>
      <SectionImg title="About us" pageName="About" imgClass="defaultSectionImg" />
      <div className="aboutContentWrap pageLayout">
        <div className="aboutMissionContainer">
          <div className="aboutMissionTextWrap">
            <h3 >Our Mission</h3>
            <p className="aboutMissionText">
              In everything we do in life safety comes first, our company was developed for this reason. People always want security; here at Essential Safety Communication we can give you that! We stand by our services; we work hard to make sure you're safe to the greatest degree possible. We will provide your Employees a knowledge to ensure all mechanical and physical aspects are covered for personal safety and health. We offer a full spectrum of services in keeping with the highest standards.
            </p>
          </div>
          <div className="aboutMissionImageWrap">
            <Slider pics={pics} />
          </div>
        </div>
          <h3 className="aboutCourseHeaderText">We are certified to teach classes by industry leading agencies</h3>
        <div className="aboutCourseContainer">
          <div className="aboutCourseWrap">
            {
            agencyInfo.map( ({name, description, logo, classesAvailable, learnMore}) => ( 
              <div className="aboutCourse" key={`${name}-courses`}>
                <div className="aboutCourseAgencyLogo">
                    {
                      typeof logo === 'string' ? (
                        <img className="aboutCourseformat" src={logo} alt={`${name} courses`} />
                      ) : (
                        logo
                      )
                    }
                </div>
                <div className="aboutCourseAgencyText">
                  <p className="aboutCourseformat">
                    {description}
                  </p>
                  {
                    learnMore ?
                    <a className="aboutLearnMoreAnchor" onClick={()=> collapseHandler(name)}><u>Learn More</u></a> : null
                  }
                  <div id={`${name}learnMore`} className={`aboutLearnMoreCollapse`}>
                    {
                      learnMore && learnMore.length > 0 ? 
                      
                      learnMore.map((text, index) => {
                        return (<p key={index} >{text}</p>)
                      }) : null 
                    }
                  </div>
                  { classesAvailable && availableAgencies.includes(name) ? 
                    <button 
                      className="aboutCourseLink" 
                      onClick={() => handleCourseNavigation(name)}
                    >
                      {`View our ${name} courses`}
                    </button>
                    : classesAvailable ? 
                    <button 
                      className="aboutCourseLink" 
                      onClick={() => handleCourseNavigation()}
                    >
                      {`View our courses`}
                    </button>
                    : null
                    }
                  
                    
                  
                </div> 
              </div>
            ))
            }
          </div>
        </div>
        <div className="aboutPoliciesLinkWrap">
          <button 
            className="aboutPoliciesLink" 
            onClick={() => history.push('/policies')}
          >
            View our policies
          </button>
        </div>
      </div>
    </div>
  );
};

export default About;